import { useArticleDurationTypeRoutes } from "./routes";
import { GetDefaultIndex } from "../../components";
import { useGetArticleDurationTypeCommonInfoQuery } from "../../features/articles/articleSubscriptionSlice";

export { useArticleDurationTypeRoutes };

export default GetDefaultIndex({ title: "نوع دوره مقالات", query: useGetArticleDurationTypeCommonInfoQuery });
